import styles from './BrandForm.module.css';
import { creatorbase } from '@round/api';
import { GenericDropdownOption } from 'App.types';
import { omit } from 'lodash';
import useTeamSelect from 'Modules/Plans/Team/hooks/useTeamSelect';
import { FormField, SelectField } from '@round/whitelabel-ui';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import { ImageUploadField } from '@round/whitelabel-ui';

export type BrandFormValues = Pick<creatorbase.PostBrandData, 'name' | 'image'> & {
    team: GenericDropdownOption<number> | null;
};

const BrandForm = () => {
    const { selectedClientId } = useClientSelect();

    const { getProps: getTeamSelectProps } = useTeamSelect({
        initOn: 'menuOpen',
        params: { client_id: selectedClientId },
        enabled: typeof selectedClientId === 'number',
    });

    return (
        <form className={styles.container}>
            <ImageUploadField name="image" />

            <FormField className={styles.field} type="text" name="name" label="Name" placeholder="Enter artist name" />

            <SelectField
                {...omit(getTeamSelectProps(), ['value', 'onChange'])}
                className={styles.field}
                name="team"
                label="Team"
                placeholder="Select team"
            />
        </form>
    );
};

export default BrandForm;
